import * as React from "react";
import { PushAttachmentStore } from "../stores/attachments";
import { CurrentTransactionStore } from "../stores/transactions";

interface ITransactionFormStore {
    pushAttachmentStore: PushAttachmentStore;
    currentTransactionStore: CurrentTransactionStore;
}

export const createTransactionFormStore = (): ITransactionFormStore => {
    return {
        pushAttachmentStore: new PushAttachmentStore(),
        currentTransactionStore: new CurrentTransactionStore(),
    };
};

export const TransactionFormStoreContext = React.createContext<ITransactionFormStore | null>(null);
